(() => {
  const LIBRARY = '__shojikiModelViewerLoad';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const views = { 'three-quarter':'25deg 78deg 108%', front:'0deg 90deg 108%', side:'90deg 90deg 108%', back:'180deg 90deg 108%', top:'0deg 0deg 108%', bottom:'0deg 180deg 108%' };
  const details = {
    body:['25deg 78deg .64m','0m .905m 0m','ハンドルと操作部の形状をご覧いただけます。'],
    cup:['25deg 82deg .47m','0m .760m .020m','透明なカップと、内部フィルターをご覧いただけます。'],
    head:['25deg 52deg .47m','0m .050m 0m','ヘッドの形状と、床に接する部分をご覧いただけます。']
  };
  function library(src) {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (!window[LIBRARY]) window[LIBRARY] = new Promise((resolve,reject) => {
      const script=document.createElement('script');script.type='module';script.src=src;
      const timer=setTimeout(()=>{window[LIBRARY]=null;reject(Error('timeout'));},25000);
      script.onload=()=>customElements.whenDefined('model-viewer').then(()=>{clearTimeout(timer);resolve();});
      script.onerror=()=>{clearTimeout(timer);window[LIBRARY]=null;script.remove();reject(Error('network'));};
      document.head.append(script);
    });
    return window[LIBRARY];
  }
  function mount(root) {
    if(root.dataset.initialized) return;
    root.dataset.initialized='true';
    const abort=new AbortController(), signal=abort.signal;
    const on=(el,event,fn)=>el.addEventListener(event,fn,{signal});
    const model=root.querySelector('model-viewer'), status=root.querySelector('.sj1d-load');
    const retry=root.querySelector('[data-action="retry"]'), rotate=root.querySelector('[data-action="rotate"]');
    const fs=root.querySelector('[data-action="fullscreen"]'), description=root.querySelector('.sj1d-description');
    const controls=[...root.querySelectorAll('[data-view],[data-focus],[data-action="in"],[data-action="out"],[data-action="reset"],[data-action="rotate"]')];
    const colors=[...root.querySelectorAll('button[data-color]')];
    let pending=false, timer, sequence=0, disposed=false, oldOverflow, previousFocus;
    const sourceFor=color=>root.dataset[color==='white'?'modelWhite':'modelBlack'];
    const posterFor=color=>root.dataset[color==='white'?'posterWhite':'posterBlack'];
    const stop=()=>{model.removeAttribute('auto-rotate');rotate.setAttribute('aria-pressed','false');};
    const busy=value=>{controls.forEach(b=>b.disabled=value);colors.forEach(b=>{b.hidden=!sourceFor(b.dataset.color);b.disabled=value;});};
    const clear=()=>root.querySelectorAll('[data-focus],[data-view]').forEach(b=>b.setAttribute('aria-pressed','false'));
    const camera=(orbit,target='0m .523m 0m')=>{stop();model.cameraTarget=target;model.cameraOrbit=orbit;if(reduced.matches)model.jumpCameraToGoal();};
    const reset=()=>{clear();model.resetTurntableRotation();camera(views['three-quarter']);root.querySelector('[data-view="three-quarter"]').setAttribute('aria-pressed','true');description.innerHTML='ドラッグで回転。<br>拡大して、細部まで。';};
    const fail=()=>{clearTimeout(timer);pending=false;stop();root.dataset.ready='false';status.hidden=false;status.querySelector('span').textContent='3Dを読み込めませんでした。再読み込みをお試しください。';retry.hidden=false;busy(true);colors.forEach(b=>b.disabled=false);};
    async function start(isRetry=false) {
      if(disposed||pending||root.dataset.ready==='true')return;
      const request=++sequence;pending=true;busy(true);status.hidden=false;retry.hidden=true;
      status.querySelector('span').textContent='3Dを読み込んでいます…';
      try {
        await library(root.dataset.viewerScript);
        if(disposed||request!==sequence)return;
        timer=setTimeout(fail,45000);
        const src=new URL(root.dataset.model,document.baseURI);
        if(isRetry)src.searchParams.set('sj1d-retry',Date.now());
        model.src=src.href;
      } catch {if(!disposed&&request===sequence)fail();}
    }
    busy(true);
    on(model,'load',()=>{clearTimeout(timer);pending=false;root.dataset.ready='true';status.hidden=true;busy(false);});
    on(model,'error',fail);
    on(model,'progress',e=>{root.querySelector('.sj1d-progress i').style.transform=`scaleX(${e.detail.totalProgress})`;});
    on(model,'camera-change',e=>{if(e.detail.source==='user-interaction'){stop();clear();}});
    on(model,'pointerdown',stop);
    colors.forEach(b=>on(b,'click',()=>{
      const color=b.dataset.color;if(color===root.dataset.color||!sourceFor(color))return;
      stop();clearTimeout(timer);pending=false;root.dataset.ready='false';root.dataset.color=color;
      root.dataset.model=sourceFor(color);const poster=posterFor(color),name=color==='white'?'ホワイト':'ブラック';
      root.querySelector('.sj1d-color-label').textContent=name;
      root.querySelector('.sj1d-static').src=poster;root.querySelector('.sj1d-static').alt=`SH-J001 ${name}`;
      model.poster=poster;model.alt=`SH-J001 ${name}の3Dモデル。ドラッグまたは矢印キーで回転できます。`;
      colors.forEach(button=>button.setAttribute('aria-pressed',String(button===b)));start();
    }));
    root.querySelectorAll('[data-view]').forEach(b=>on(b,'click',()=>{clear();model.resetTurntableRotation();camera(views[b.dataset.view]);b.setAttribute('aria-pressed','true');description.textContent='角度を変えたあとも、ドラッグで自由に回転できます。';}));
    root.querySelectorAll('[data-focus]').forEach(b=>on(b,'click',()=>{clear();model.resetTurntableRotation();const [orbit,target,text]=details[b.dataset.focus];camera(orbit,target);b.setAttribute('aria-pressed','true');description.textContent=text;}));
    function collapse(){root.classList.remove('is-expanded');document.body.style.overflow=oldOverflow||'';fs.setAttribute('aria-label','全画面で見る');previousFocus?.focus();}
    on(root,'click',async e=>{
      const button=e.target.closest('[data-action]');if(!button)return;
      const action=button.dataset.action;
      if(action==='retry'){model.removeAttribute('src');start(true);}
      if(action==='reset')reset();
      if(action==='in'||action==='out'){stop();const {theta,phi,radius}=model.getCameraOrbit();model.cameraOrbit=`${theta}rad ${phi}rad ${radius*(action==='in'?.78:1.28)}m`;if(reduced.matches)model.jumpCameraToGoal();}
      if(action==='rotate'){const enabled=rotate.getAttribute('aria-pressed')!=='true';rotate.setAttribute('aria-pressed',String(enabled));model.toggleAttribute('auto-rotate',enabled);model.setAttribute('rotation-per-second','14deg');model.setAttribute('auto-rotate-delay','0');}
      if(action==='fullscreen'){
        if(document.fullscreenElement){await document.exitFullscreen();return;}
        if(root.classList.contains('is-expanded')){collapse();return;}
        previousFocus=document.activeElement;
        if(root.requestFullscreen){try{await root.requestFullscreen();fs.setAttribute('aria-label','全画面を閉じる');return;}catch{}}
        oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';root.classList.add('is-expanded');fs.setAttribute('aria-label','全画面を閉じる');fs.focus();
      }
    });
    on(document,'keydown',e=>{
      if(!root.classList.contains('is-expanded'))return;
      if(e.key==='Escape')collapse();
      if(e.key==='Tab'){
        const buttons=[...root.querySelectorAll('button:not([disabled])')].filter(b=>!b.hidden),first=buttons[0],last=buttons.at(-1);
        if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
      }
    });
    on(document,'visibilitychange',()=>{if(document.hidden)stop();});
    on(document,'fullscreenchange',()=>{if(!document.fullscreenElement)fs.setAttribute('aria-label','全画面で見る');});
    const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)start();else stop();}),{rootMargin:'200px'});observer.observe(root);
    const viewing=new IntersectionObserver(entries=>entries.forEach(e=>root.classList.toggle('is-in-view',e.intersectionRatio>=.5)),{threshold:[0,.5,1]});viewing.observe(root);
    root._sj1dCleanup=()=>{disposed=true;sequence++;abort.abort();observer.disconnect();viewing.disconnect();root.classList.remove('is-in-view');clearTimeout(timer);stop();if(root.classList.contains('is-expanded'))collapse();};
  }
  const scan=parent=>parent.querySelectorAll('.sj1d').forEach(mount);
  scan(document);
  if(!window.__shj001SectionEvents){
    window.__shj001SectionEvents=true;
    document.addEventListener('shopify:section:load',e=>scan(e.target));
    document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.sj1d').forEach(el=>el._sj1dCleanup?.()));
  }
})();
